import { useState, useEffect } from 'react';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  GoogleAuthProvider,
  signInWithPopup,
} from 'firebase/auth';
import { auth } from '../firebase-config';
import './Auth.css';

function Auth({ onClose }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [user, setUser] = useState(null);
  const [mode, setMode] = useState('signin');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        onClose();
      }
    });
    return () => unsubscribe();
  }, [onClose]);

  const handleSignIn = async (e) => {
    e.preventDefault();
    try {
      setError('');
      await signInWithEmailAndPassword(auth, email, password);
      setEmail('');
      setPassword('');
    } catch (err) {
      setError(err.message);
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    try {
      setError('');
      await createUserWithEmailAndPassword(auth, email, password);
      setEmail('');
      setPassword('');
    } catch (err) {
      setError(err.message);
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      setError('');
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
    } catch (err) {
      setError(err.message);
    }
  };

  if (user) {
    return null;
  }

  return (
    <div className="auth-overlay">
      <div className="auth-modal">
        <button className="close-btn" onClick={onClose}>×</button>
        <div className="split-container">
          <div className="login-side">
            <h2>{mode === 'signup' ? 'Create Account' : 'Login'}</h2>
            {error && <p className="error">{error}</p>}
            <form onSubmit={mode === 'signup' ? handleSignUp : handleSignIn}>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button type="submit">
                {mode === 'signup' ? 'Sign Up' : 'Login'}
              </button>
            </form>

            {mode === 'signin' && (
              <>
                <div className="divider">
                  <span>or</span>
                </div>

                <button 
                  className="google-btn" 
                  onClick={handleGoogleSignIn}
                >
                  <img 
                    src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" 
                    alt="Google"
                  />
                  Sign in with Google
                </button>
              </>
            )}
          </div>
          <div className="welcome-side">
            <h2>Welcome!</h2>
            {mode === 'signin' ? (
              <>
                <p>Don't have an account?</p>
                <button 
                  onClick={() => setMode('signup')} 
                  className="signup-btn"
                >
                  Sign Up
                </button>
              </>
            ) : (
              <>
                <p>Already have an account?</p>
                <button 
                  onClick={() => setMode('signin')} 
                  className="signup-btn"
                >
                  Sign In
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Auth; 